import { render, staticRenderFns } from "./TreeviewDraggableNode.vue?vue&type=template&id=4bf48162&scoped=true&"
import script from "./TreeviewDraggableNode.vue?vue&type=script&lang=js&"
export * from "./TreeviewDraggableNode.vue?vue&type=script&lang=js&"
import style0 from "./TreeviewDraggableNode.vue?vue&type=style&index=0&id=4bf48162&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf48162",
  null
  
)

export default component.exports